// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  Login,
  AlterarSenha,
  Logout,
} from './';

export default {
  path: 'acesso-sistema',
  name: 'Acesso sistema',
  childRoutes: [
    { path: 'Login', name: 'Login', component: Login },
    { path: 'alterar-senha', name: 'Alterar senha', component: AlterarSenha },
    { path: 'logout', name: 'Logout', component: Logout },
  ],
};



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/route.js